// src/config/logger.config.js

export const LOGGER_CONFIG = {
  // How often to flush logs (milliseconds)
  flushInterval: process.env.REACT_APP_LOG_FLUSH_INTERVAL || 10000, // 10s

  // Max logs to buffer before forcing a flush
  maxBufferSize: process.env.REACT_APP_LOG_BUFFER_SIZE || 50,

  // Timeout for log requests (milliseconds)
  requestTimeout: 5000,

  // Fields to redact from logs
  sensitiveFields: [
    "password",
    "token",
    "accessToken",
    "refreshToken",
    "creditCard",
    "apiKey",
  ],
};
